import { encode } from "iconv-lite";
import Papa from "papaparse";

export const exportCsv = (data: any[], dateNow: string, plugin: IPluginSettings) => {
    const result = renamedObject(data, plugin);
    
    const csvContent = Papa.unparse(result, {
      delimiter: ";",
    });
    
    const encoding = "win1251";
    const encodedContent = encode(csvContent, encoding);
    
    // Преобразуем Buffer в Uint8Array для совместимости с Blob
    const uint8Array = new Uint8Array(encodedContent);
    
    const blob = new Blob([uint8Array], { type: `text/csv;charset=${encoding}` });
    
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${plugin.name} ${dateNow}.csv`;
    document.body.appendChild(a);
    a.click();
    
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
}

const renamedObject = (data: any[], plugin: IPluginSettings) => {
    return data.map((value) => {
        return( Object.keys(value).reduce((acc, key) => {
            const newKey = plugin.columns.find(x => x.propertyName === key)?.displayName ?? key;
            return { ...acc, [newKey]: value[key] };
          }, {}));
    })
}